import React, { useEffect } from 'react';
import * as cls from './apis-and-integrations.module.css';
import { Link } from 'react-router-dom';
import { IMG_PATH, ROUTES_PATHS } from '../../../constants';
import Meta from '../../../../components/meta';
import Hero from '../../../ui/components/hero/hero';
import { Button } from '../../../ui/components/button';
import { WhyIntegrate } from './why-integrate';
import { BuildWithVoltaware } from './build-with-voltaware';
import { HowItWorks } from './how-it-works';
import { FooterCTAs } from './footer-ctas';

export const V2APIsAndIntegrations = () => {
  useEffect(() => {
    const $header = document.querySelector('header');
    const $main = document.querySelector('main');
    if ($header) {
      $header.style.backgroundColor = 'transparent';
      $header.style.boxShadow = 'none';
      $header.style.transition = 'all .33s ease-in-out';
    }
    if ($main) {
      $main.style.marginTop = 0;
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY > 100) {
        if ($header) {
          $header.style.backgroundColor = '';
          $header.style.boxShadow = '';
        }
      } else {
        if ($header) {
          $header.style.backgroundColor = 'transparent';
          $header.style.boxShadow = 'none';
        }
      }
    });

    return () => {
      window.removeEventListener('scroll', () => {
        if ($header) {
          $header.style.backgroundColor = '';
          $header.style.boxShadow = '';
          $header.style.transition = '';
        }
      });
      if ($main) {
        $main.style.marginTop = '';
      }
      if ($header) {
        $header.style.backgroundColor = '';
        $header.style.boxShadow = '';
      }
    };
  }, []);

  return (
    <>
      <Meta
        title="APIs & Integrations | Voltaware"
        description="Integrate Voltaware’s energy intelligence into your product with REST APIs, dashboards, and white-label apps. Add appliance-level insights, behavioural analytics, and smart-meter data intelligence without building your own AI stack."
        // image="https://voltaware.com/img/v2/our-technology/.svg"
      />

      <Hero
        className={cls.hero}
        items={[
          {
            img: `${IMG_PATH}/our-technology/apis-and-integrations/apis-and-integrations-hero.png`,
            imgAlt: 'API nodes connecting to apps and dashboards',
            title: 'APIs & Integrations',
            text: 'Plug structured energy insights into your product.',
            caption:
              'Voltaware’s APIs and integration services help you launch appliance breakdowns, usage events, and targeted digital journeys, without building your own disaggregation stack.',
            action: (
              <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
                <Button>Book Demo</Button>
              </Link>
            ),
          },
        ]}
      />

      <div className={cls['apis-and-integrations-page']}>
        <BuildWithVoltaware />

        <HowItWorks />

        <WhyIntegrate />

        <FooterCTAs />
      </div>
    </>
  );
};
